export default "__VITE_ASSET__64590bcc__"